import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle
} from "../../basic/alert-dialog";
import {useTranslationWithKeys} from "../../../hooks/useTranslationWithKeys";
import {Loader2} from "lucide-react";

interface RemoveMemberAlertDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    onConfirm: () => void;
    memberName?: string;
    memberLicenses?: string[];
    isRemoving?: boolean;
}

export function RemoveMemberAlertDialog({
                                            open,
                                            onOpenChange,
                                            onConfirm,
                                            memberName,
                                            memberLicenses,
                                            isRemoving = false
                                        }: RemoveMemberAlertDialogProps) {
    const {t} = useTranslationWithKeys();
    const hasLicenses = memberLicenses?.length > 0;
    const licenseText = hasLicenses
        ? ` This will revoke their ${memberLicenses.length} license${memberLicenses.length > 1 ? 's' : ''} and they will lose access.`
        : ' They will be removed from the team.';

    return (
        <AlertDialog open={open} onOpenChange={onOpenChange}>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle>Remove Team Member</AlertDialogTitle>
                    <AlertDialogDescription>
                        Are you sure you want to remove {memberName}?{licenseText}
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel disabled={isRemoving}>{t('common.action.cancel')}</AlertDialogCancel>
                    <AlertDialogAction
                        className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
                        onClick={onConfirm}
                        disabled={isRemoving}
                    >
                        {isRemoving ? (
                            <>
                                <Loader2 className="mr-2 h-4 w-4 animate-spin"/>
                                {t('common.removing')}
                            </>
                        ) : (
                            t('common.action.remove')
                        )}
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}